import { useMemoAsync } from "@opendash/core";
import { Descriptions } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React from "react";
import { TicketTypedMetaField } from "../../../types/TicketMeta";

type Props = {
  meta: TicketTypedMetaField & { type: "select_parse" };
};

export const MetaSelectParse = observer((props: Props) => {
  const parseObject = useMemoAsync(() => {
    const query = new Parse.Query(props.meta.className);
    if (props.meta.multiple) query.containedIn("objectId", props.meta.value);
    else query.equalTo("objectId", props.meta.value);
    return query.find();
  }, [props.meta.value, props.meta.className]);

  const displayValue = parseObject
    ? parseObject.map((item) => item.get(props.meta.display)).join(", ")
    : "";

  return (
    <Descriptions.Item label={props.meta.label} key={props.meta.label}>
      {displayValue}
    </Descriptions.Item>
  );
});
